<template>
  <div :style="`height:${contentHeight}px`">
    <div :style="`height:${imageDivHeight}px`">
      <div class="d-flex">
        <div class="side-frame"></div>
        <div class="d-flex align-items-center">
          <span style="font-size: 14px; color: #606266">{{
            $l('INDEX.form_label_picture') || '图片'
          }}</span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <div>
            <el-upload
              id="uploader"
              ref="uploader"
              multiple
              action="/oss/ossUploadReturnUrlAndFileId"
              :file-list="listImageFile"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onImageChange"
              :disabled="!materialCode"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <el-button
                v-if="!disabled"
                class="ml-2"
                style="font-size: 14px;"
                type="text"
                :disabled="!materialCode"
                >{{
                  $l('INDEX.form_label_upload_picture') || '上传图片'
                }}</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap block">
        <vuedraggable
          @end="draggableEnd"
          tag="div"
          draggable=".draggable-item"
          class="d-flex flex-wrap"
        >
          <div
            class="draggable-item"
            v-for="(item, index) in listImageView"
            :key="index"
          >
            <el-tooltip
              placement="top"
              :content="$l('INDEX.tooltip_mouse_click_drag') || '鼠标点击拖动'"
            >
              <div class="image-box">
                <span
                  class="default-icon"
                  v-if="listImage[index].isDefaultImage"
                >
                  <i class="el-icon-success"></i>
                </span>
                <el-image
                  style="width: 100%; height: 100%"
                  fit="scale-down"
                  :src="item"
                  :preview-src-list="listImageView"
                ></el-image>
                <div
                  class="shadow d-flex align-items-center justify-content-center"
                >
                  <div>
                    <span @click="onImagePreview(index)">
                      <i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      v-if="!disabled"
                      @click="onImageCheck(index)"
                      class="ml-2"
                    >
                      <i class="el-icon-check"></i
                    ></span>
                    <span
                      v-if="!disabled"
                      @click="materialCode ? onImageDel(index) : null"
                      class="ml-2"
                      :class="{ 'disabled-icon': !materialCode }"
                    >
                      <i class="el-icon-delete-solid"></i>
                    </span>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </vuedraggable>
      </div>
    </div>
    <upload-images
      v-if="imageVisible"
      :materialCode="materialCode"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialCode="amzSkuMaterialCode"
      :visible="imageVisible"
      @close="() => (imageVisible = false)"
      @reload="getImageData()"
    />
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImage"
        :src="item.originImageUrl || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>

    <div class="mt-2" :style="`height:${docDiveHeight}px`">
      <div class="doc-table">
        <doc-table
          :disabled="disabled"
          @uploadFile="uploadFile()"
          @reload="getDocData()"
          :tableData="listDoc"
          :tableHeight="docDiveHeight"
        />
      </div>
    </div>
    <UploadFiles
      v-if="fileVisible"
      :materialCode="materialCode"
      :visible="fileVisible"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialCode="amzSkuMaterialCode"
      @close="() => (fileVisible = false)"
      @reload="getDocData()"
    />
  </div>
</template>
<script>
import UploadFiles from './upload-file.vue'
import DocTable from './doc-table'
import EditLoading from '@/mixins/edit-loading'
import vuedraggable from 'vuedraggable'
export default {
  mixins: [EditLoading],
  props: {
    materialCode: String,
    amzSkuMaterialCode: String,
    amzSkuCode: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { UploadFiles, DocTable, vuedraggable },
  data() {
    return {
      listDoc: [],
      listImage: [],
      imageVisible: false,
      fileVisible: false,
      imageDivHeight: 300,
      docDiveHeight: 300,

      listImageFile: [],
      uploadFileMaxLimit: 8,
    }
  },
  computed: {
    // contentHeight() {
    //   return window.innerHeight - 210
    // },
    listImageView() {
      return this.listImage.map((image) => {
        return image.originImageUrl
      })
    },
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length
    },
  },
  mounted() {
    this.init()
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.contentHeight = window.innerHeight - 210
      this.imageDivHeight = this.contentHeight / 2
      this.docDiveHeight = this.contentHeight / 2
    },
    init() {
      if (!this.materialCode) return
      this.getImageData()
      this.getDocData()
    },
    getImageData() {
      this.$api
        .materialInfoImageListApi({ materialCode: this.materialCode })
        .then((res) => {
          this.listImage = res.body.data
        })
    },
    getDocData() {
      this.$api
        .materialInfoDocListApi({ materialCode: this.materialCode })
        .then((res) => {
          this.listDoc = res.body.data
        })
    },
    uploaImage() {
      this.imageVisible = true
    },
    uploadFile() {
      this.fileVisible = true
    },
    onImagePreview(index) {
      // 点击大图显示图片预览组件
      if (this.listImage.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    onImageCheck(index) {
      if (!this.materialCode) {
        this.$message.warning('请先保存基本信息')
        return
      }
      this.loadingOpen()

      const image = this.listImage[index]
      const params = {
        materialCode: this.materialCode,
        materialImgCode: image.materialImgCode,
        amzSkuCode: this.amzSkuCode,
        amzSkuMaterialCode: this.amzSkuMaterialCode,
      }
      this.$api
        .setMaterialInfoDefaultImageApi(params)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: '设置成功！',
            type: 'success',
          })
          this.getImageData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
    onImageChange(file) {
      if (!this.materialCode) {
        this.$message.warning('请先保存基本信息')
        this.clearFiles()
        return
      }

      //获取添加文件进来的状态
      if (file.status !== 'ready') return

      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (this.isEmpty) {
        this.$message.warning(
          this.$l('INDEX.tips_upload_file') || '请选择您需要上传的图片！'
        )
        return
      }
      this.loadingOpen()
      const listImage = await this.uploadImages()
      const params = {
        materialCode: this.materialCode,
        amzSkuCode: this.amzSkuCode,
        amzSkuMaterialCode: this.amzSkuMaterialCode,
        listImage,
      }
      this.uploadInfoSave(params)
        .then((res) => {
          this.loadingClose()
          this.clearFiles()
          const { status } = res
          if (status !== 200) {
            this.$message.error(
              this.$l('INDEX.uploader_label_status_error') || '上传失败'
            )
            return
          }
          this.getImageData()
        })
        .catch(() => {
          this.clearFiles()
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    uploadImages() {
      if (this.isEmpty) return Promise.resolve([])
      const uploadTask = this.listImageFile.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          originImageCode: res.body.fileId,
          originImageUrl: res.body.url,
          originImageSpec: image.raw.type,
          uid: image.uid,
        }))
      })
      return Promise.all(uploadTask)
    },
    async uploadInfoSave(params) {
      if (this.isEmpty) {
        this.$message.warning(`请选择您需要上传的资料！`)
        return
      }

      return await this.$api.materialInfoImageBatchUploadApi(params)
    },
    onImageDel(index) {
      if (!this.materialCode) {
        this.$message.warning('请先保存基本信息')
        return
      }

      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const image = this.listImage[index]
        const params = {
          materialImgCode: image.materialImgCode,
          materialCode: this.materialCode,
          amzSkuCode: this.amzSkuCode,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
        }
        this.loadingOpen()
        this.imageDel(params)
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status === 200) {
              this.getImageData()
            } else {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
            }
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    async imageDel(params) {
      return await this.$api.materialInfoImageDelApi(params)
    },

    reloadImages() {
      this.listImage = []
      this.getImageData()
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (newIndex === oldIndex) return
      const oldEl = { ...this.listImage[oldIndex] }
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listImage[i] = this.listImage[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = oldIndex; i < newIndex; i++) {
          this.listImage[i] = this.listImage[i + 1]
        }
      }
      this.listImage[newIndex] = oldEl
      this.updateSortOrder(this.listImage)
    },
    updateSortOrder(params) {
      this.loadingOpen()
      this.updateOrder(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            this.reloadImages()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async updateOrder(params) {
      return await this.$api.materialInfoImageUpdateSortOrderApi({
        listImage: params,
        materialCode: this.materialCode,
        amzSkuCode: this.amzSkuCode,
        amzSkuMaterialCode: this.amzSkuMaterialCode,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 5px;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;

  .disabled-icon {
    color: #909399;
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
